import { Link } from "react-router-dom";
import Sidebar from "./shop-sidebar";
import PropertyCardShop from "../display/property-card-6";
import { usePropertyStore } from "../../store/usePropertyStore";
import { useMemo, useEffect } from "react";
import { PropertyEndpoint } from "../../api";
const ShopLeftSidebar = () => {
    const { properties, simpleFilter, advancedFilter, setAdvancedFilter, setProperties, direct, setDirect } = usePropertyStore();



    useEffect(() => {
        const propertyEndpoint = new PropertyEndpoint();

        const fetchPropertyData = async () => {
            const response = await propertyEndpoint.getProperties();
            setProperties(response);
        };

        fetchPropertyData();
    }, []); 



    const { search = "", types = [], harga = [], provinces = [], cities = [], sort = "default", page = 1, perPage = 6 } = advancedFilter || {};

    const simpleFiltered = useMemo(() => {

        // Ensure properties is an array
        if (!Array.isArray(properties)) {
            return [];
        }

        if (!direct) {
            return properties;
        }

        // If no simple filters are active, return all properties
        const hasActiveFilters = simpleFilter.property_type || simpleFilter.province || simpleFilter.city;
        if (!hasActiveFilters) {
            return [...properties];
        }

        setDirect(false);

        return properties.filter((p) => {
            const matchType =
                !simpleFilter.property_type || p?.property_type === simpleFilter.property_type;
            const matchProvince = !simpleFilter.province || p?.province === simpleFilter.province;
            const matchCity = !simpleFilter.city || p?.city === simpleFilter.city;


            return matchType && matchProvince && matchCity;
        });
    }, [properties, simpleFilter]);

    const filteredProperties = useMemo(() => {
        let result = [...simpleFiltered];
        if (search) {
            const s = search.toLowerCase();
            result = result.filter(
                (p) =>
                    p.name.toLowerCase().includes(s) ||
                    p.city.toLowerCase().includes(s) ||
                    p.province.toLowerCase().includes(s)
            );
        }

        if (types.length > 0) {
            result = result.filter((p) => types.includes(p.property_type));
        }

        if (harga.length > 0) {
            result = result.filter((p) =>
                harga.some((range) => {
                    if (range === "low") return Number(p.rent_price) < 2000000;
                    if (range === "medium")
                        return Number(p.rent_price) >= 2000000 && Number(p.rent_price) < 5000000;
                    if (range === "high") return Number(p.rent_price) >= 5000000;
                    return true;
                })
            );
        }

        if (Array.isArray(provinces) && provinces.length > 0) {
            result = result.filter((p) => provinces.includes(p.province));
        }

        if (Array.isArray(cities) && cities.length > 0) {
            result = result.filter((p) => cities.includes(p.city));
        }

        return result;
    }, [simpleFiltered, search, types, harga, provinces, cities]);

    const sortedProperties = useMemo(() => {
        const sorted = [...filteredProperties];

        if (sort === "low-high") sorted.sort((a, b) => Number(a.rent_price) - Number(b.rent_price));
        if (sort === "high-low")
            sorted.sort((a, b) => Number(b.rent_price) - Number(a.rent_price));

        return sorted;
    }, [filteredProperties, sort]);

    const totalPages = Math.ceil(sortedProperties.length / perPage);

    const paginatedProperties = useMemo(() => {
        const start = (page - 1) * perPage;
        return sortedProperties.slice(start, start + perPage);
    }, [sortedProperties, page, perPage]);

    const handleSortChange = (e) => {
        const val = e.target.value;

        if (val.includes("rendah")) setAdvancedFilter("sort", "low-high");
        else if (val.includes("tinggi")) setAdvancedFilter("sort", "high-low");
        else setAdvancedFilter("sort", "default");

        setAdvancedFilter("page", 1);
    };



    return (
        <div className="ltn__product-area ltn__product-gutter">
            <div className="container">
                <div className="row">
                    {/* MAIN CONTENT */}
                    <div className="col-lg-8 order-lg-2 mb-100">
                        {/* SORT */}
                        <div className="ltn__shop-options">
                            <ul className="justify-content-start">
                                <li>
                                    <div className="short-by text-center">
                                        <select className="nice-select" onChange={handleSortChange}>
                                            <option>Urutan Default</option>
                                            <option>
                                                Urutkan berdasarkan harga: rendah ke tinggi
                                            </option>
                                            <option>
                                                Urutkan berdasarkan harga: tinggi ke rendah
                                            </option>
                                        </select>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        {/* SEARCH */}
                        <div className="ltn__search-widget mb-30 mt-3">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={search}
                                onChange={(e) => {
                                    setAdvancedFilter("search", e.target.value);
                                    setAdvancedFilter("page", 1);
                                }}
                            />
                        </div>

                        {/* PROPERTY LIST */}
                        <div className="row">
                            {paginatedProperties.length > 0 ? (
                                paginatedProperties.map((property, i) => (
                                    <PropertyCardShop property={property} key={i} />
                                ))
                            ) : (
                                <div className="col-lg-12 text-center">
                                    <p>Tidak ada properti ditemukan.</p>
                                </div>
                            )}
                        </div>

                        {/* PAGINATION */}
                        <div className="ltn__pagination-area text-center">
                            <div className="ltn__pagination">
                                <ul>
                                    <li>
                                        <Link
                                            to="#"
                                            onClick={() =>
                                                setAdvancedFilter("page", Math.max(page - 1, 1))
                                            }
                                        >
                                            <i className="fas fa-angle-double-left" />
                                        </Link>
                                    </li>

                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <li key={i} className={page === i + 1 ? "active" : ""}>
                                            <Link
                                                to="#"
                                                onClick={() => setAdvancedFilter("page", i + 1)}
                                            >
                                                {i + 1}
                                            </Link>
                                        </li>
                                    ))}

                                    <li>
                                        <Link
                                            to="#"
                                            onClick={() =>
                                                setAdvancedFilter(
                                                    "page",
                                                    Math.min(page + 1, totalPages)
                                                )
                                            }
                                        >
                                            <i className="fas fa-angle-double-right" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* SIDEBAR */}
                    <Sidebar />
                </div>
            </div>
        </div>
    );
};

export default ShopLeftSidebar;
